import { render, staticRenderFns } from "./ExplainerText.vue?vue&type=template&id=915ec908&scoped=true&"
import script from "./ExplainerText.vue?vue&type=script&lang=js&"
export * from "./ExplainerText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915ec908",
  null
  
)

export default component.exports